/**
 * Returns milliseconds using power of 2 logic. Returns 0 for negative args.
 * */
export const getIncrementalBackoff = (iteration: number) => {
  if (Number.isNaN(iteration)) return 0;
  return iteration ** 2 * 1000;
};
